import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import {useShowSingleCaseStudyQuery,useUpdateCaseStudyMutation} from "../../../Services/api";
export default function UpdateCaseStudy(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        title: Yup.string().required("title fields is required"),
        file: Yup.string().required("file fields is required"),
    });
      const {
        data: ShowSingleCaseStudy,
        
      } =  useShowSingleCaseStudyQuery({  params:props['id']});

      const [UpdateCaseStudy,isLoading] = useUpdateCaseStudyMutation();
      
      const SingleCaseStudy= ShowSingleCaseStudy? ShowSingleCaseStudy?.data[0] : 0;
     
      var  defaultValues={
        title:SingleCaseStudy?.title,
        link:SingleCaseStudy?.file,
      };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
      useEffect(() => {
        reset(defaultValues)
      },[SingleCaseStudy]) 
    const editCaseStudy = (values,e) => {
      const formData = new FormData();
      formData.append('title', values.title);
      formData.append('file', values.file[0]);
      formData.append('id', props['id']);
      UpdateCaseStudy(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error)
        });
        notify();
    };
   
    return (
        
        <div className="modal fade" id="fullscreenModalCaseStudy">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Case Study</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Case Study</h5>
                        <form onSubmit={handleSubmit(editCaseStudy)} >

                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                    <div className="col-sm-10">
                                        <input type="name" {...register("title" ,{ required: true})} className="form-control" />
                                        {errors.title && <span  className="text-danger">Title is required</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize"> File </label>
                                    <div className="col-sm-10">
                                        <input type="file" {...register('file' ,{ required: true })} className="form-control" />
                                        {errors.file && <span  className="text-danger">file  is required</span>}
                                    </div>
                                   
                                </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label"></label>
                                <div className="col-sm-10">
                                        {isLoading.status !=='pending' ?        
                                        <button type="submit" className="btn btn-warning w-100" >Update Case Study</button>
                                                :
                                        <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div>
                            </div>
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}